import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function SalesSettingsTab() {
  const { can } = useAuth();
  const [v, setV] = useState("");
  const [cur, setCur] = useState(null);
  const edit = can("ayarlar", "edit");
  useEffect(() => { api.get("/settings/sales").then(({ data }) => { setCur(data); setV(data.min_margin_pct); }); }, []);
  const save = async (patch, msg) => {
    try { const { data } = await api.put("/settings/sales", patch); setCur(data); setV(data.min_margin_pct); toast.success(msg); }
    catch (e) { toast.error(apiError(e)); }
  };
  if (!cur) return <div className="panel h-32 animate-pulse" />;
  return (
    <div className="grid lg:grid-cols-2 gap-4 max-w-4xl" data-testid="sales-settings-tab">
      <div className="panel p-4">
        <h3 className="text-base font-semibold text-slate-800">Minimum Sipariş Marjı</h3>
        <p className="text-xs text-slate-500 mb-3">Sipariş marjı bu değerin altındaysa proforma ONAY BEKLİYOR işaretiyle kaydedilir; yönetici onayı olmadan faturalaştırılamaz. Değişiklikler denetim kaydına yazılır.</p>
        <div className="flex items-center gap-2">
          <span className="font-mono">%</span>
          <Input type="number" step="0.5" min="0" max="100" className="w-28 h-9" value={v} onChange={(e) => setV(e.target.value)} disabled={!edit} data-testid="min-margin-input" />
          {edit && <Button size="sm" className="bg-blue-600 hover:bg-blue-700" onClick={() => save({ min_margin_pct: Number(v) }, "Marj eşiği güncellendi")} disabled={String(v) === String(cur.min_margin_pct)} data-testid="min-margin-save">Kaydet</Button>}
        </div>
      </div>
      <div className="panel p-4">
        <div className="flex items-center justify-between gap-3">
          <h3 className="text-base font-semibold text-slate-800">Depo süreci aktif</h3>
          <Switch checked={cur.depo_enabled} disabled={!edit} data-testid="depo-enabled-switch"
            onCheckedChange={(c) => window.confirm(c ? "Depo süreci açılsın mı? Proformalar Stok Ayrıldı → Toplanıyor → Kontrol → Paketlendi → Sevke Hazır adımlarından geçip faturalaşır." : "Depo süreci kapatılsın mı? Proformalar doğrudan faturalaştırılır, depo kuyruğu gizlenir.") && save({ depo_enabled: c }, c ? "Depo süreci açıldı" : "Depo süreci kapatıldı")} />
        </div>
        <p className="text-xs text-slate-500 mt-2" data-testid="depo-flow-desc">
          {cur.depo_enabled ? "AÇIK: PROFORMA → STOK AYRILDI → TOPLANIYOR → KONTROL → PAKETLENDİ → SEVKE HAZIR → FATURALAŞTI (barkod kuralları geçerli)." : "KAPALI: PROFORMA → FATURALAŞTI. Depo kuyruğu boş/gizli."} Değişiklik denetim kaydına yazılır.
        </p>
      </div>
    </div>
  );
}
